// @flow
import { RESORT_INTRODUCTION } from 'Client/cms/toolkit/constants';
import gqlClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_INTRODUCTION } from 'Utils/request/requestDictionary';
import { buildProductArgs } from 'Utils/graphql';

type CMSProps = {
  communityLabel: string,
  id: string,
  imageSrc: string,
  resortId: string,
  toSummerLabel: string,
  toWinterLabel: string,
};

export const productIntroductionResolver = {
  name: RESORT_INTRODUCTION,
  resolve(
    appContext: AppContext,
    props: CMSProps,
    pageContext: PageContext,
    location: ProductRouterLocation,
  ) {
    const { urlParams } = location;
    const { resortId: productId } = props;
    const productArgs = buildProductArgs(productId, urlParams);

    const query = `query {
      resort(resortId:"${productId}"){
        comfort
        descriptionTitle
        description
        destination {
          country
        }
        icon
        images
        isDoubleSeason
        linkedResort{
          href
        }
        name
        seasonName
        tripadvisor(resortId:"${productId}") {
          rating
          ratingImageUrl
        }
        type
      }
      productCommunity(${productArgs}) {
        questions {
          id
        }
      }
      config {
        common {
          viewMore
          loadLess
        }
        resort {
          resortIntroduction {
            communityLabel
            toSummerLabel
            toWinterLabel
          }
        }
      }
    }`;

    return gqlClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_INTRODUCTION,
      strictErrors: false,
    });
  },
};
